import { getMatchStringRegExp } from "./regexp";
function compare(source, target, strict) {
    if (strict) {
        const regexp = getMatchStringRegExp(target);
        return !!source.match(regexp)?.length;
    }
    return source.toLowerCase().includes(target.toLowerCase());
}
export function checkItem(item, { match, by, strict }) {
    if (by) {
        return compare(item[by] || "", match, strict);
    }
    return compare(item.text || "", match, strict);
}
export function treeFilter(data = [], filter) {
    return data
        .map(object => ({
        ...object,
        children: treeFilter(object.children, filter),
    }))
        .filter(object => checkItem(object, filter) || object?.children?.length);
}
export function getFilteredChildren(data) {
    const filteredChildren = {};
    const setFilteredChildren = (data) => {
        for (let index = 0; index < data.length; index++) {
            const task = data[index];
            if (!filteredChildren[task.id]) {
                filteredChildren[task.id] = [...task?.children];
            }
            if (task?.children?.length) {
                setFilteredChildren(task.children);
            }
        }
    };
    setFilteredChildren(data);
    return filteredChildren;
}
//# sourceMappingURL=filter.js.map